"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 19. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var immutable_1 = require("immutable");
/**
 * KPI phase is mechanism how to group KPI calculators and control when these groups are calculated. Phases are derived
 * from expected time when regular calculation should occur. But further refinement in grouping may be made.
 * Clients may specify their own phases when recalculating.
 *
 * @author Stepan Mik
 */


var KpiPhase;

(function (KpiPhase) {
  /**
   *  Recalculation is expected any time before promo starts.
   */
  KpiPhase["PreEval"] = "PRE_EVAL";
  /**
   *  Recalculation is expected until day window starts. The phase is active
   *  until promotion ends. Calculator must be ready to compute some value even if
   *  window was not started yet. After window start, calculators should use previous KPI
   *  value, if such value does not exist, calculator should report warning and set KPI to NaN
   */

  KpiPhase["PreEvalFreeze"] = "PRE_EVAL_FREEZE"; //Forecast = 'FORECAST',

  /**
   *  Recalculation is expected any time after promo starts.
   */

  KpiPhase["PostEval"] = "POST_EVAL";
  /**
   *  Recalculation is expected any time after promo starts, but the KPI can not be split.
   */

  KpiPhase["PostEvalNoSplit"] = "POST_EVAL_NO_SPLIT";
  /**
   *  Recalculation is expected  until day window ends. The phase is active during promo
   *  validity period. Calculator must be ready to compute some value even if
   *  window was not started yet or is in progress. After window end, calculators should use previous KPI
   *  value, if such value does not exist, calculator should report warning and set KPI to NaN
   */

  KpiPhase["PostEvalFreeze"] = "POST_EVAL_FREEZE";
  /**
   *  Recalculation is expected any time after promo starts and KPI is related to receipts.
   */

  KpiPhase["ReceiptsPost"] = "RECEIPTS_POST";
  /**
   *  Recalculation is expected 1.4. when vendor allowances are fixed for the last year.
   */

  KpiPhase["VendorAllowance"] = "VENDOR_ALLOWANCE";
})(KpiPhase = exports.KpiPhase || (exports.KpiPhase = {})); //tslint:disable:no-namespace
//tslint:disable:variable-name


(function (KpiPhase) {
  KpiPhase.All = immutable_1.Set.of(KpiPhase.PreEval, KpiPhase.PreEvalFreeze, KpiPhase.PostEval, KpiPhase.PostEvalNoSplit, KpiPhase.PostEvalFreeze, KpiPhase.ReceiptsPost, KpiPhase.VendorAllowance);
  KpiPhase.AllPostEval = immutable_1.Set.of(KpiPhase.PostEval, KpiPhase.ReceiptsPost, KpiPhase.PostEvalFreeze, KpiPhase.PostEvalNoSplit);
  KpiPhase.AllPreEval = immutable_1.Set.of(KpiPhase.PreEval, KpiPhase.PreEvalFreeze);
  KpiPhase.AllButFreeze = immutable_1.Set.of(KpiPhase.PreEval, KpiPhase.PostEvalNoSplit, KpiPhase.PostEval, KpiPhase.ReceiptsPost);

  function isKpiPhaseSet(v) {
    return v instanceof immutable_1.Set;
  }

  KpiPhase.isKpiPhaseSet = isKpiPhaseSet;

  function matchPhase(phase, required) {
    if (isKpiPhaseSet(phase)) {
      return !required.intersect(phase).isEmpty();
    } else {
      return required.has(phase);
    }
  }

  KpiPhase.matchPhase = matchPhase;
})(KpiPhase = exports.KpiPhase || (exports.KpiPhase = {}));